import {
    apiRequest,
    bobotPenilaianIndividuList,
    bobotPenilaianIndividuActive,
    bobotPenilaianIndividuInactive,
} from "../../../../../../services/adapters/master/bobotPenilaianIndividuService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", bobotPenilaianIndividuList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", bobotPenilaianIndividuInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", bobotPenilaianIndividuActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository